import React, { Component } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import jwt_decode from "jwt-decode";
import CryptoJS from 'crypto-js';
import "./leftSidebar.css";

export default class LeftSidebar extends Component {

  constructor(props) {
    super(props);
    this.state = {
      profileOpen: false,
      mobileOpen: false,
    };
    this.handleOverlayClick = this.handleOverlayClick.bind(this);
  }

  componentDidMount() {
    // Close sidebar on route change (mobile UX)
    this.setState({ mobileOpen: false });
  }

  logoutUser() {
    localStorage.removeItem("jwtToken");
    window.location.replace("/");
  }

  handleOverlayClick() {
    this.setState({ mobileOpen: false });
  }

  toggleMobile() {
    this.setState(prev => ({ mobileOpen: !prev.mobileOpen }));
  }

  render() {
    const token = localStorage.getItem("jwtToken");
    const decodedToken = jwt_decode(token);
    const userInfo = decodedToken;
    const user_role = userInfo.role_as;
    const user_id = userInfo.user_id;

    const secretKey = 'Maxx12#';
    const encryptUserId = (userId) => {
      const encrypted = CryptoJS.AES.encrypt(userId, secretKey).toString();
      return encrypted.replace(/\//g, '_').replace(/\+/g, '-').replace(/=/g, '');
    };
    const encryptedUserId = encryptUserId(user_id);

    const { profileOpen, mobileOpen } = this.state;

    // Helper: close sidebar on nav click (mobile)
    const onNavClick = () => {
      if (mobileOpen) this.setState({ mobileOpen: false });
    };

    const createAgent = (() => {
      if (user_role === 2) {
        return (
          <>
            <a className="lsb-item" href="/subreseller-index" onClick={onNavClick}>
              <div className="lsb-icon">
                <i className="material-icons" style={{ fontSize: '16px', color: 'inherit' }}>grid_view</i>
              </div>
              <span className="lsb-label">Create Affiliate Manager</span>
            </a>
            <Link className="lsb-item" to={`/down-list/${encryptedUserId}`} onClick={onNavClick}>
              <div className="lsb-icon">
                <i className="material-icons" style={{ fontSize: '16px', color: 'inherit' }}>account_tree</i>
              </div>
              <span className="lsb-label">Downline List</span>
            </Link>
          </>
        );
      } else if (user_role === 2.1) {
        return (
          <>
            <Link className="lsb-item" to="/user-balance-report" onClick={onNavClick}>
              <div className="lsb-icon"><i className="material-icons" style={{ fontSize: '16px' }}>swap_horiz</i></div>
              <span className="lsb-label">Balance Transfer</span>
            </Link>
            <Link className="lsb-item" to="/balance-from-admin" onClick={onNavClick}>
              <div className="lsb-icon"><i className="material-icons" style={{ fontSize: '16px' }}>move_to_inbox</i></div>
              <span className="lsb-label">Deposit Received</span>
            </Link>
            {/* <Link className="lsb-item" to="/add-wallet-list" onClick={onNavClick}>
              <div className="lsb-icon"><i className="material-icons" style={{ fontSize: '16px' }}>account_balance_wallet</i></div>
              <span className="lsb-label">Add Wallet</span>
            </Link> 
            <Link className="lsb-item" to="/reffered-list" onClick={onNavClick}>
              <div className="lsb-icon"><i className="material-icons" style={{ fontSize: '16px' }}>group</i></div>
              <span className="lsb-label">User List</span>
            </Link>*/}
            <Link className="lsb-item" to="/pending-balance-request" onClick={onNavClick}>
              <div className="lsb-icon"><i className="material-icons" style={{ fontSize: '16px' }}>arrow_downward</i></div>
              <span className="lsb-label">Deposit Request</span>
            </Link>
            <Link className="lsb-item" to="/pending-withdraw-request" onClick={onNavClick}>
              <div className="lsb-icon"><i className="material-icons" style={{ fontSize: '16px' }}>arrow_upward</i></div>
              <span className="lsb-label">Withdraw Request</span>
            </Link>
            <Link className="lsb-item" to="/affiliate-index" onClick={onNavClick}>
              <div className="lsb-icon"><i className="material-icons" style={{ fontSize: '16px' }}>person_add</i></div>
              <span className="lsb-label">Create Affiliate Agent</span>
            </Link>
            <Link className="lsb-item" to="/affiliate-pending-withdraw" onClick={onNavClick}>
              <div className="lsb-icon"><i className="material-icons" style={{ fontSize: '16px' }}>pending</i></div>
              <span className="lsb-label">Affiliate Pending Withdraw</span>
            </Link>
            <Link className="lsb-item" to={`/down-list/${encryptedUserId}`} onClick={onNavClick}>
              <div className="lsb-icon"><i className="material-icons" style={{ fontSize: '16px' }}>account_tree</i></div>
              <span className="lsb-label">Downline List</span>
            </Link>
            <Link className="lsb-item" to="/new-chats" onClick={onNavClick}>
              <div className="lsb-icon"><i className="material-icons" style={{ fontSize: '16px' }}>chat</i></div>
              <span className="lsb-label">New Chats</span>
            </Link> 
          </>
        );
      }
    })();

    const cashInReport = (() => {
      if (user_role === 4) {
        return (
          <>
            <Link className="lsb-item" to="/reffered-list" onClick={onNavClick}>
              <div className="lsb-icon"><i className="material-icons" style={{ fontSize: '16px' }}>group</i></div>
              <span className="lsb-label">User List</span>
            </Link>
            <Link className="lsb-item" to="/balance-withdraw-history" onClick={onNavClick}>
              <div className="lsb-icon"><i className="material-icons" style={{ fontSize: '16px' }}>arrow_upward</i></div>
              <span className="lsb-label">Balance Withdraw</span>
            </Link>
            <Link className="lsb-item" to="/commission-history" onClick={onNavClick}>
              <div className="lsb-icon"><i className="material-icons" style={{ fontSize: '16px' }}>receipt_long</i></div>
              <span className="lsb-label">Commission History</span>
            </Link>
          </>
        );
      }
    })();

    return (
      <>
        {/* ── Mobile hamburger button ── */}
        <button
          className="lsb-toggle"
          onClick={() => this.toggleMobile()}
          aria-label={mobileOpen ? "Close menu" : "Open menu"}
        >
          <i className="material-icons">
            {mobileOpen ? 'close' : 'menu'}
          </i>
        </button>

        {/* ── Mobile backdrop overlay ── */}
        <div
          className={`lsb-overlay ${mobileOpen ? 'visible' : ''}`}
          onClick={this.handleOverlayClick}
        />

        {/* ── Sidebar ── */}
        <div className={`lsb ${mobileOpen ? 'open' : ''}`}>

          {/* Logo */}
          <div className="lsb-logo">
            <div className="lsb-logo-icon">Baji Pro</div>
            <div className="lsb-logo-name"><span> </span></div>
          </div>

          {/* User info */}
          <div className="lsb-user">
            <div className="lsb-avatar">MA</div>
            <div style={{ minWidth: 0 }}>
              <div className="lsb-uname">Affiliate Agent</div>
              <div className="lsb-urole">{userInfo.user_id}</div>
            </div>
          </div>

          {/* Nav */}
          <div className="lsb-scroll">
            <div className="lsb-section">Main</div>

            <Link className="lsb-item" to="/agent" onClick={onNavClick}>
              <div className="lsb-icon">
                <i className="material-icons" style={{ fontSize: '16px' }}>grid_view</i>
              </div>
              <span className="lsb-label">Dashboard</span>
            </Link>

            {cashInReport && <div className="lsb-section">Reports</div>}
            {cashInReport}

            {createAgent && <div className="lsb-section">Management</div>}
            {createAgent}

            <div className="lsb-section">Settings</div>

            {/* Profile dropdown */}
            <div
              className="lsb-item"
              onClick={() => this.setState({ profileOpen: !profileOpen })}
              style={{ cursor: 'pointer' }}
              role="button"
              aria-expanded={profileOpen}
            >
              <div className="lsb-icon">
                <i className="material-icons" style={{ fontSize: '16px' }}>manage_accounts</i>
              </div>
              <span className="lsb-label">Profile Manage</span>
              <i className="material-icons" style={{
                fontSize: '16px',
                color: '#4A4F63',
                marginLeft: 'auto',
                flexShrink: 0,
                transform: profileOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform .2s ease'
              }}>expand_more</i>
            </div>

            <div className={`lsb-sub ${profileOpen ? 'open' : ''}`}>
              <Link className="lsb-subitem" to="/profile-manage" onClick={onNavClick}>Profile Setting</Link>
              <Link className="lsb-subitem" to="/password-manage" onClick={onNavClick}>Password Manage</Link>
              <Link className="lsb-subitem" to="/tpin-manage" onClick={onNavClick}>S-Pin Manage</Link>
            </div>
          </div>

          {/* Logout */}
          <div className="lsb-footer">
            <button className="lsb-logout" onClick={this.logoutUser}>
              <i className="material-icons" style={{ fontSize: '16px', color: '#E8380A' }}>logout</i>
              <span>Log Out</span>
            </button>
          </div>
        </div>
      </>
    );
  }
}
